const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
  cartError: "cart-error",
};

const STORE_CONFIG = {
  workingDays: {
    monday: {
      start: "0900",
      end: "1700",
    },
    tuesday: {
      start: "0900",
      end: "1700",
    },
    wednesday: {
      start: "0900",
      end: "1700",
    },
    thursday: {
      start: "0900",
      end: "1700",
    },
    friday: {
      start: "0900",
      end: "1700",
    },
    saturday: {
      start: "1200",
      end: "1600",
    },
    sunday: false,
  },
};
